// extracted by mini-css-extract-plugin
export default {"Icon":"StatusIcon_Icon__167Eh","Quarter":"StatusIcon_Quarter__y91X1","Half":"StatusIcon_Half__1Jmp8","ThreeQuarters":"StatusIcon_ThreeQuarters__rJ3ZP"};